/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for alarm search:
 *   * ALL : All fields
 *   * CHARGEPOINT_ID : OCPP ChargePoint Id
 *   * TRANSACTION_ID : OCPP Transaction Id
 */
export enum ChargeSearchFilter {
  ALL = 'ALL',
  CHARGEPOINT_ID = 'CHARGEPOINT_ID',
  TRANSACTION_ID = 'TRANSACTION_ID'
}
